import {
  GET_CATALOGS_MENU,
  GET_CATALOGS_MENU_FAIL,
  GET_CATALOGS_MENU_SUCCESS,
  SET_STATE_MENUCATALOGS
} from "./actionTypes"

export const getCatalogs = ( params ) => ({
  type: GET_CATALOGS_MENU,
  payload: { params },
})

export const setState = ( loading ) => ({
  type: SET_STATE_MENUCATALOGS,
  payload: loading,
})

export const getCatalogsSuccess = (catalogs,totalPages, currentPage) => ({
  type: GET_CATALOGS_MENU_SUCCESS,
  payload: {catalogs:catalogs, total:totalPages, currentPage:currentPage}
})

export const getCatalogsFail = error => ({
  type: GET_CATALOGS_MENU_FAIL,
  payload: error,
})
